

import { useState } from "react"
import { Modal, Button, Accordion } from "react-bootstrap"
import Swal from "sweetalert2"
import { components } from "react-select"
import PropTypes from "prop-types"
import Select from "react-select"
import QuestionnaireSection from "../Components/PanchkarmaQuestionaire"
import FollowUpForm from "../Components/PanchkarmFollowUpForm"
import { handleSuccess, showErrorAlert } from "../../../../services/ErrorHandlingService"

const PrescriptionFollowUp = ({
  selectedPrescriptionForFollowup,
  prescriptionKey,
  onClose,
  patientId,
  patientName,
  patientGender,
}) => {
  const [showDelayModal, setShowDelayModal] = useState(false)
  const [delayDays, setDelayDays] = useState("")
  const [showScheduleModal, setShowScheduleModal] = useState(false)
  const [showFollowUpForm, setShowFollowUpForm] = useState(false)
  const [showReminderModal, setShowReminderModal] = useState(false)
  const [reminderDate, setReminderDate] = useState("")
  const [reminderTime, setReminderTime] = useState("")
  const [prescriptionExplained, setPrescriptionExplained] = useState({})
  const [medicineStarted, setMedicineStarted] = useState({})
  const [selectedScheduleReason, setSelectedScheduleReason] = useState(null)
  const [downloadingId, setDownloadingId] = useState(null)
  const [consentChecked, setConsentChecked] = useState(false);
  const [sendingLink, setSendingLink] = useState(false);
  // API loading states (kept for UI consistency)
  const [prescriptionExplainedLoading, setPrescriptionExplainedLoading] = useState({})
  const [medicineStartedLoading, setMedicineStartedLoading] = useState({})
  const [reminderLoading, setReminderLoading] = useState(false)
  const [delayLoading, setDelayLoading] = useState(false)
  const [scheduledListLoading, setScheduledListLoading] = useState(false)

  // Date states
  const [prescriptionExplainedDates, setPrescriptionExplainedDates] = useState({})
  const [medicineStartedDates, setMedicineStartedDates] = useState({})
  const [prescriptionExplainedSaved, setPrescriptionExplainedSaved] = useState({})
  const [medicineStartedSaved, setMedicineStartedSaved] = useState({})

  const prescriptionSummaryData = {
    ConsultingDate: "2025-08-19",
    ConsultingPaymentDate: "2025-08-19",
    ConvertPaymentDate: "2025-08-19",
    MedicineDesignDate: "2025-08-19",
    MedicinePreparedDate: "2025-08-19",
    MedicineDeliveredDate: "2025-08-19",
  }

  const scheduledListData = {
    data: [
      {
        schedule_id: 1,
        followup_count: "1st Followup",
        followup_frequency_days: 7,
        followup_date: "2024-02-01",
        schedule_status: "completed",
      },
      {
        schedule_id: 2,
        followup_count: "2nd Followup",
        followup_frequency_days: 14,
        followup_date: "2024-02-15",
        schedule_status: "ongoing",
      },
      {
        schedule_id: 3,
        followup_count: "3rd Followup",
        followup_frequency_days: 21,
        followup_date: "2024-03-01",
        schedule_status: "scheduled",
      },
    ],
  }

  const prescriptionId = selectedPrescriptionForFollowup?.prescription_id

  const handleDownloadReceipt = async (prescriptionId, receiptDownloadLink) => {
    if (!receiptDownloadLink) {
      Swal.fire({
        title: "Download Not Available",
        text: "Receipt download link is not available for this prescription.",
        icon: "warning",
        confirmButtonText: "OK",
      })
      return
    }

    setDownloadingId(prescriptionId)

    // Simulate download
    setTimeout(() => {
      setDownloadingId(null)
      Swal.fire({
        title: "Success!",
        text: "Receipt downloaded successfully!",
        icon: "success",
        confirmButtonText: "OK",
      })
    }, 2000)
  }

  const followupOptions = (scheduledListData?.data || []).map((schedule) => ({
    value: schedule.schedule_id,
    label: `${schedule.followup_count} (${schedule.followup_frequency_days} days)`,
    date: schedule.followup_date,
  }))

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props
    return (
      <div ref={innerRef} {...innerProps} style={{ padding: "10px" }}>
        <strong>{data.label}</strong>
        <div style={{ fontSize: "12px", color: "#666" }}>Date: {data.date}</div>
      </div>
    )
  }

  CustomOption.propTypes = {
    data: PropTypes.object.isRequired,
    innerRef: PropTypes.func,
    innerProps: PropTypes.object,
  }

  const CustomSingleValue = (props) => {
    const { data } = props
    return (
      <components.SingleValue {...props}>
        {data.label} – {data.date}
      </components.SingleValue>
    )
  }

  CustomSingleValue.propTypes = {
    data: PropTypes.object.isRequired,
  }

  const appointments = [
    {
      date: "08/04/2025",
      notes: [
        {
          title: "Prescription",
          content: (
            <div>
              <div
                style={{
                  fontSize: "0.9rem",
                  color: "#6c757d",
                  marginTop: "5px",
                  marginBottom: "1rem",
                }}
              >
                <strong>Prescribed Date:</strong> {selectedPrescriptionForFollowup?.date || "N/A"} &nbsp;|&nbsp;
                <strong>Duration:</strong> {selectedPrescriptionForFollowup?.duration || "N/A"} days &nbsp;|&nbsp;
                <strong>Prescribed By:</strong> {selectedPrescriptionForFollowup?.prescribedBy || "Unknown Doctor"}
              </div>
              {(() => {
                const regularMedicines =
                  selectedPrescriptionForFollowup?.medicines?.filter((medicine) => medicine.is_custom === "No") || []
                const customMedicines =
                  selectedPrescriptionForFollowup?.medicines?.filter((medicine) => medicine.is_custom === "Yes") || []

                return (
                  <>
                    {/* Regular Medicines Table */}
                    {regularMedicines.length > 0 && (
                      <div
                        style={{
                          border: "2px solid #ddd",
                          borderRadius: "5px",
                          marginBottom: regularMedicines.length > 0 && customMedicines.length > 0 ? "24px" : "0",
                          overflowX: "auto",
                        }}
                      >
                        {regularMedicines.length > 0 && customMedicines.length > 0 && (
                          <h5 className="p-2 border-bottom mb-0">Regular Medicines</h5>
                        )}
                        <table
                          className="table header-border mb-0"
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#f8f9fa",
                              zIndex: 10,
                              borderBottom: "2px solid #ddd",
                            }}
                          >
                            <tr className="table-info">
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                Medicine Name
                              </th>
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>Dose</th>
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                Frequency
                              </th>
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                Quantity
                              </th>
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                How to Take
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {regularMedicines.map((medicine, index) => (
                              <tr key={medicine.prescription_medicine_id || index}>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.medicine_name}
                                </td>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.dose}
                                </td>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.frequency}
                                </td>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.qty}
                                </td>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.how_to_take}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Custom Medicines Table */}
                    {customMedicines.length > 0 && (
                      <div
                        style={{
                          border: "2px solid #ddd",
                          borderRadius: "5px",
                          marginBottom: "0",
                          overflowX: "auto",
                        }}
                      >
                        {regularMedicines.length > 0 && customMedicines.length > 0 && (
                          <h5 className="p-2 border-bottom mb-0">Custom Medicines</h5>
                        )}
                        <table
                          className="table header-border mb-0"
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#f8f9fa",
                              zIndex: 10,
                              borderBottom: "2px solid #ddd",
                            }}
                          >
                            <tr className="table-info">
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                Medicine Name
                              </th>
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>Dose</th>
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                Frequency
                              </th>
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                Quantity
                              </th>
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                Duration
                              </th>
                              <th style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                How to Take
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {customMedicines.map((medicine, index) => (
                              <tr key={medicine.prescription_medicine_id || index}>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.medicine_name}
                                </td>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.dose}
                                </td>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.frequency}
                                </td>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.qty}
                                </td>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.custom_duration_in_days || "N/A"}
                                </td>
                                <td style={{ padding: "10px", textAlign: "center", verticalAlign: "middle" }}>
                                  {medicine.how_to_take}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Show message if no medicines */}
                    {regularMedicines.length === 0 && customMedicines.length === 0 && (
                      <div className="text-center text-muted py-4">No medicines prescribed</div>
                    )}
                  </>
                )
              })()}
            </div>
          ),
        },
      ],
    },
  ]

  const [filteredAppointments] = useState([...appointments])



  const handleSaveReminder = async () => {
    if (!reminderDate || !reminderTime) {
      Swal.fire({
        title: "Missing Information",
        text: "Please select both date and time for the reminder.",
        icon: "warning",
        confirmButtonText: "OK",
      })
      return
    }

    const selectedDateTime = new Date(`${reminderDate}T${reminderTime}`)
    const now = new Date()
    if (selectedDateTime <= now) {
      Swal.fire({
        title: "Invalid Date/Time",
        text: "Please select a future date and time for the reminder.",
        icon: "warning",
        confirmButtonText: "OK",
      })
      return
    }

    setReminderLoading(true)

    // Simulate API call
    setTimeout(() => {
      setReminderDate("")
      setReminderTime("")
      setShowReminderModal(false)
      setReminderLoading(false)
      Swal.fire({
        title: "Success!",
        text: `Follow-up reminder has been scheduled for ${selectedDateTime.toLocaleString()}.`,
        icon: "success",
        confirmButtonText: "OK",
      })
    }, 1500)
  }

  const targetDate = "08/04/2025"
  const appointmentsOnDate = filteredAppointments.filter((appointment) => appointment.date === targetDate)

  const formatDate = (dateStr) => {
    if (!dateStr) return "-"
    const date = new Date(dateStr)
    if (isNaN(date)) return "-"
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  if (!selectedPrescriptionForFollowup) {
    return null
  }

  const handleSaveDelay = async () => {
    if (!delayDays) {
      Swal.fire({
        title: "Missing Information",
        text: "Please enter delay days",
        icon: "warning",
        confirmButtonText: "OK",
      })
      return
    }
    if (!selectedScheduleReason?.value) {
      Swal.fire({
        title: "Missing Selection",
        text: "Please select a schedule reason before saving delay.",
        icon: "warning",
        confirmButtonText: "OK",
      })
      return
    }

    setDelayLoading(true)

    // Simulate API call
    setTimeout(() => {
      setShowDelayModal(false)
      setDelayDays("")
      setDelayLoading(false)
      Swal.fire({
        title: "Success!",
        text: `Follow-up delay of ${delayDays} days has been added successfully.`,
        icon: "success",
        confirmButtonText: "OK",
      })
    }, 1500)
  }

  const handleViewSchedule = async () => {
    setScheduledListLoading(true)

    // Simulate API call
    setTimeout(() => {
      setScheduledListLoading(false)
      setShowScheduleModal(true)
    }, 1000)
  }
  const handleSendConsentLink = async () => {
    setSendingLink(true);
    try {
      // TODO: replace with actual API call
      await new Promise((resolve) => setTimeout(resolve, 1500));

      handleSuccess("Consent form link sent successfully!", "success");
    } catch (error) {
      showErrorAlert("Failed to send consent form link.", "error");
    } finally {
      setSendingLink(false);
    }
  };
  const receiptDownloadLink = selectedPrescriptionForFollowup?.receipt_download_link

  const disableViewScheduleButton =
    scheduledListLoading ||
    (selectedPrescriptionForFollowup?.prescription_explained === "No" &&
      selectedPrescriptionForFollowup?.medicine_started === "No")

  return (
    <div style={{ marginTop: "-2rem" }}>
      <div className="card shadow-sm border">
        <div className="card-header text-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <i className="fas fa-chart-line me-2"></i> Patient Follow-Up Tracking
          </h5>
          <div className="d-flex gap-2">
            {/* PDF Download Button */}


            <Button variant="outline-light" size="sm" onClick={handleViewSchedule}>
              {scheduledListLoading ? (
                <>
                  <i className="fas fa-spinner fa-spin me-1"></i> Loading...
                </>
              ) : (
                "View Schedule"
              )}
            </Button>
            <Button variant="outline-light" size="sm" onClick={onClose}>
              <i className="fas fa-times"></i>
            </Button>

            {/* Schedule Modal */}
            <Modal show={showScheduleModal} onHide={() => setShowScheduleModal(false)} size="lg" centered>
              <Modal.Header closeButton>
                <Modal.Title>Follow-Up Status</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ paddingLeft: "15px", paddingRight: "15px", maxHeight: "70vh", overflowY: "auto" }}>
                <div style={{ padding: "20px 0 10px" }}>
                  <div
                    style={{
                      display: "flex",
                      overflowX: "auto",
                      gap: "40px",
                      paddingBottom: "20px",
                      paddingTop: "10px",
                      position: "relative",
                    }}
                  >
                    {(scheduledListData?.data || []).map((schedule, index, array) => {
                      const getStatusColor = (status) => {
                        switch (status?.toLowerCase()) {
                          case "completed":
                            return "#0d6efd"
                          case "ongoing":
                            return "#0dcaf0"
                          case "scheduled":
                            return "#dc3545"
                          case "pending":
                            return "#ffc107"
                          default:
                            return "#6c757d"
                        }
                      }

                      const formatDate = (dateStr) => {
                        if (!dateStr) return "N/A"
                        const date = new Date(dateStr)
                        return date.toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })
                      }

                      return (
                        <div key={index} style={{ position: "relative", textAlign: "center", minWidth: "150px" }}>
                          {/* Dot */}
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              backgroundColor: getStatusColor(schedule.schedule_status),
                              border: "2px solid #fff",
                              boxShadow: `0 0 0 3px ${getStatusColor(schedule.schedule_status)}`,
                              margin: "0 auto",
                              zIndex: 2,
                            }}
                          />

                          {/* Connector Line */}
                          {index < array.length - 1 && (
                            <div
                              style={{
                                position: "absolute",
                                top: "9px",
                                left: "50%",
                                width: "100%",
                                height: "2px",
                                backgroundColor: "#ccc",
                                zIndex: 0,
                                transform: "translateX(10px)",
                              }}
                            ></div>
                          )}

                          {/* Info Below Dot */}
                          <div style={{ marginTop: "12px" }}>
                            <h6 style={{ fontSize: "0.95rem", fontWeight: 600, marginBottom: "4px" }}>
                              {schedule.followup_count}
                            </h6>
                            <div style={{ fontSize: "0.8rem", color: "#555", marginBottom: "4px" }}>
                              ({schedule.followup_frequency_days} days)
                            </div>
                            <p style={{ fontSize: "0.85rem", margin: 0 }}>
                              <strong>Date:</strong> {formatDate(schedule.followup_date)}
                            </p>
                            <p style={{ fontSize: "0.85rem", margin: 0 }}>
                              <strong>Status:</strong> {schedule.schedule_status}
                            </p>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-danger" onClick={() => setShowScheduleModal(false)}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>

        {/* Prescription info section */}
        <div className="card-body border-bottom">
          <div className="row">
            <div className="col-md-4">
              <p className="fs-5 mb-0">
                <strong>Karma Prescribed By:</strong> {selectedPrescriptionForFollowup?.prescribedBy || "Unknown Doctor"}
              </p>
            </div>
            <div className="col-md-4">
              <p className="fs-5 mb-0">
                <strong>Date:</strong> {selectedPrescriptionForFollowup?.date || "Unknown Date"}
              </p>
            </div>
            <div className="col-md-4">

            </div>
          </div>
        </div>

        <div className="card-body">
          {/* Summary Section */}


          {/* Summary API data */}
          <div className="mb-4 border rounded p-3 shadow-sm bg-white mt-4">
            <h5 className="fw-bold mb-3">Summary</h5>
            <div className="row mb-3">
              {[
                { label: "Consulting Date", value: formatDate(prescriptionSummaryData.ConsultingDate) },
                { label: "Consulting Payment Date", value: formatDate(prescriptionSummaryData.ConsultingPaymentDate) },
                { label: "Convert Payment Date", value: formatDate(prescriptionSummaryData.ConvertPaymentDate) },
                { label: "Medicine Design Date", value: formatDate(prescriptionSummaryData.MedicineDesignDate) },
                { label: "Medicine Prepared Date", value: formatDate(prescriptionSummaryData.MedicinePreparedDate) },
                { label: "Medicine Delivered Date", value: formatDate(prescriptionSummaryData.MedicineDeliveredDate) },
              ].map((item, idx) => (
                <div className="col-md-4 mb-2" key={idx}>
                  <strong>{item.label}:</strong> {item.value}
                </div>
              ))}
            </div>
          </div>

          {/* Prescription Tracking */}
          {appointmentsOnDate.map((appointment, index) =>
            appointment.notes.map((note, noteIndex) => {
              if (note.title.trim() === "Prescription") {
                const prescriptionKey = `${index}-${noteIndex}`
                const currentPrescriptionExplainedState =
                  prescriptionExplained[prescriptionKey] !== undefined
                    ? prescriptionExplained[prescriptionKey]
                    : selectedPrescriptionForFollowup?.prescription_explained === "Yes"
                const displayPrescriptionExplainedDate =
                  prescriptionExplainedDates[prescriptionKey] ||
                  selectedPrescriptionForFollowup?.prescription_explained_date

                const currentMedicineStartedState =
                  medicineStarted[prescriptionKey] !== undefined
                    ? medicineStarted[prescriptionKey]
                    : selectedPrescriptionForFollowup?.medicine_started === "Yes"
                const displayMedicineStartedDate =
                  medicineStartedDates[prescriptionKey] || selectedPrescriptionForFollowup?.medicine_started_date

                return (
                  <div key={`prescription-${prescriptionKey}`} className="mb-4 border rounded p-3 shadow-sm bg-white">
                    {/* Is Prescription Explained? */}


                    {/* Medicine Explained Date */}
                    {/* Consent Form Section */}
                    <div className="d-flex flex-wrap align-items-center mb-3">
                      <label className="form-check-label me-2 mb-2 mb-sm-0">
                        Consent Status:
                      </label>

                      {consentChecked ? (
                        <span className="badge bg-success me-2 mb-2 mb-sm-0">
                          Consent Provided
                        </span>
                      ) : (
                        <span className="badge bg-danger me-2 mb-2 mb-sm-0">
                          Consent Not Provided
                        </span>
                      )}

                      <button
                        className="btn btn-outline-success btn-sm mb-2 mb-sm-0"
                        onClick={handleSendConsentLink}
                        disabled={sendingLink}
                      >
                        {sendingLink ? (
                          <>
                            <i className="fas fa-spinner fa-spin me-1"></i> Sending...
                          </>
                        ) : (
                          "Send Link"
                        )}
                      </button>
                    </div>


                    {/* Bottom Buttons */}
                    <div className="d-flex flex-wrap gap-2 mt-3">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => setShowFollowUpForm(true)}
                        disabled={showFollowUpForm}
                      >
                        Add Follow-Up
                      </button>

                      <button
                        className="btn btn-outline-info"
                        onClick={() => setShowReminderModal(true)}
                      >
                        Add Follow-Up Reminder
                      </button>

                      <button
                        className="btn btn-outline-info"
                        onClick={() => setShowDelayModal(true)}
                      >
                        Add Follow-Up Delay
                      </button>
                    </div>


                    {/* Delay Modal */}
                    <Modal
                      show={showDelayModal}
                      onHide={() => {
                        setShowDelayModal(false)
                        setDelayDays("")
                      }}
                      backdrop="static"
                      keyboard={false}
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Set Follow-Up Delay</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="mb-3">
                          <label htmlFor="delayDays" className="form-label">
                            Delay (in days)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter the delay days"
                            id="delayDays"
                            name="delayDays"
                            value={delayDays}
                            min={0}
                            onChange={(e) => setDelayDays(e.target.value)}
                            required
                            autoComplete="off"
                            style={{
                              WebkitAppearance: "none",
                              MozAppearance: "textfield",
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Schedule Follow-Up</label>
                          <Select
                            value={selectedScheduleReason}
                            onChange={setSelectedScheduleReason}
                            options={followupOptions}
                            isClearable
                            placeholder="Select Schedule Follow-Up"
                            className="react-select-container"
                            classNamePrefix="react-select"
                            components={{
                              Option: CustomOption,
                              SingleValue: CustomSingleValue,
                            }}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                minHeight: "50px",
                                height: "50px",
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                lineHeight: "50px",
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: "4px",
                              }),
                              indicatorSeparator: (provided) => ({
                                ...provided,
                                display: "none",
                              }),
                            }}
                          />
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="outline-danger"
                          onClick={() => {
                            setShowDelayModal(false)
                            setDelayDays("")
                          }}
                          disabled={delayLoading}
                        >
                          Cancel
                        </Button>
                        <Button variant="primary" onClick={handleSaveDelay} disabled={delayLoading}>
                          {delayLoading ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-1"></i> Saving...
                            </>
                          ) : (
                            "Save"
                          )}
                        </Button>
                      </Modal.Footer>
                    </Modal>

                    {/* Reminder Modal */}
                    {showReminderModal && (
                      <Modal
                        show={showReminderModal}
                        onHide={() => {
                          setShowReminderModal(false)
                          setReminderDate("")
                          setReminderTime("")
                        }}
                        backdrop="static"
                        keyboard={false}
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Add Follow-Up Reminder</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="mb-3">
                            <label htmlFor="reminderDate" className="form-label">
                              Reminder Date
                            </label>
                            <div className="position-relative">
                              <input
                                type="date"
                                className="form-control"
                                id="reminderDate"
                                name="reminderDate"
                                value={reminderDate}
                                min={new Date().toISOString().split("T")[0]}
                                onChange={(e) => setReminderDate(e.target.value)}
                                required
                                autoComplete="off"
                                style={{
                                  paddingRight: "40px",
                                  WebkitAppearance: "none",
                                  MozAppearance: "textfield",
                                }}
                              />
                              <i
                                className="fa fa-calendar position-absolute"
                                style={{
                                  right: "15px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  pointerEvents: "none",
                                  fontSize: "18px",
                                  color: "#888",
                                  zIndex: 2,
                                }}
                              ></i>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="reminderTime" className="form-label">
                              Reminder Time
                            </label>
                            <div className="position-relative">
                              <input
                                type="time"
                                className="form-control"
                                id="reminderTime"
                                name="reminderTime"
                                value={reminderTime}
                                onChange={(e) => setReminderTime(e.target.value)}
                                required
                                autoComplete="off"
                                style={{
                                  paddingRight: "40px",
                                  WebkitAppearance: "none",
                                  MozAppearance: "textfield",
                                }}
                              />
                              <i
                                className="fa fa-clock position-absolute"
                                style={{
                                  right: "15px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  pointerEvents: "none",
                                  fontSize: "18px",
                                  color: "#888",
                                  zIndex: 2,
                                }}
                              ></i>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => {
                              setShowReminderModal(false)
                              setReminderDate("")
                              setReminderTime("")
                            }}
                            disabled={reminderLoading}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSaveReminder}
                            disabled={reminderLoading}
                          >
                            {reminderLoading ? (
                              <>
                                <i className="fas fa-spinner fa-spin me-1"></i> Saving...
                              </>
                            ) : (
                              "Save"
                            )}
                          </button>
                        </Modal.Footer>
                      </Modal>
                    )}
                  </div>
                )
              }
              return null
            }),
          )}

          {/* Follow-up Form */}
          <FollowUpForm
            showFollowUpForm={showFollowUpForm}
            setShowFollowUpForm={setShowFollowUpForm}
            followupOptions={followupOptions}
            CustomOption={CustomOption}
            CustomSingleValue={CustomSingleValue}
            prescriptionId={prescriptionId}
            patientId={patientId}
          />

          <QuestionnaireSection prescriptionId={prescriptionId} />
        </div>
      </div>
    </div>
  )
}

PrescriptionFollowUp.propTypes = {
  selectedPrescriptionForFollowup: PropTypes.object.isRequired,
  prescriptionKey: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  patientName: PropTypes.string,
  patientGender: PropTypes.string,
}

export default PrescriptionFollowUp;
